import actions from "./actions";

const {
  PRODUCT_TYPE_BEGIN,
  PRODUCT_TYPE_SUCCESS,
  PRODUCT_TYPE_ERR,
  MODEL_BEGIN,
  MODEL_SUCCESS,
  MODEL_ERR,
  EMPLOYEE_DETAIL_BEGIN,
  EMPLOYEE_DETAIL_SUCCESS,
  EMPLOYEE_DETAIL_ERR,
  EMPLOYEE_DETAIL_RESET,
  EXCHANGE_MODEL_BEGIN,
  EXCHANGE_MODEL_SUCCESS,
  EXCHANGE_MODEL_ERR,
  EMPLOYEE_BASED_STORE_LIST_BEGIN,
  EMPLOYEE_BASED_STORE_LIST_SUCCESS,
  EMPLOYEE_BASED_STORE_LIST_ERR,
  BRAND_BEGIN,
  BRAND_SUCCESS,
  BRAND_ERR,
} = actions;

const initialStateFilter = { data: "", loading: false, error: null };

export const productTypeReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PRODUCT_TYPE_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case PRODUCT_TYPE_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case PRODUCT_TYPE_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getModelReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case MODEL_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case MODEL_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case MODEL_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getEmployeeDetailReducers = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case EMPLOYEE_DETAIL_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case EMPLOYEE_DETAIL_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        error: null,
        loading: false,
      };
    case EMPLOYEE_DETAIL_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    case EMPLOYEE_DETAIL_RESET:
      return initialStateFilter;
    default:
      return state;
  }
};

export const exchangeModelDetailReducer = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_MODEL_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case EXCHANGE_MODEL_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
        error: null,
      };
    case EXCHANGE_MODEL_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const employeeBasedStoreListReducer = (
  state = initialStateFilter,
  action
) => {
  const { type, data, err } = action;
  switch (type) {
    case EMPLOYEE_BASED_STORE_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case EMPLOYEE_BASED_STORE_LIST_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
        error: null,
      };
    case EMPLOYEE_BASED_STORE_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getBrandReducers = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case BRAND_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case BRAND_SUCCESS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
        error: null,
      };
    case BRAND_ERR:
      return {
        ...initialStateFilter,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};
